import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';

/**
 * A chegada do número protagonista.
 *
 * ELE NÃO CONTA DE ZERO ATÉ O VALOR, e isso é decisão de produto, não de gosto.
 * Contador crescente é o efeito que todo painel usa, e aqui ele mentiria: por
 * meio segundo a tela exibiria R$ 0, R$ 900, R$ 1.800 — medições que ninguém
 * fez, no lugar onde este produto promete que ausência nunca vira número. Numa
 * ferramenta que o dono usa para decidir se saca pró-labore, um algarismo falso
 * de passagem é caro demais pelo efeito.
 *
 * O que ele faz é o número CHEGAR: sobe 10px, sai do desfoque e assenta. É o
 * mesmo número o tempo todo — só a nitidez e a posição mudam. Some inteiro para
 * quem pediu menos movimento no sistema (o `MotionConfig` do casco cuida).
 */
const ValorQueChega = ({ children, atraso = 0, sx }) => (
  <Box
    component={motion.span}
    initial={{ opacity: 0, y: 10, filter: 'blur(7px)' }}
    animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
    transition={{ duration: 0.55, delay: atraso, ease: [0.22, 1, 0.36, 1] }}
    sx={{ display: 'inline-block', willChange: 'transform, filter', ...sx }}
  >
    {children}
  </Box>
);

export default ValorQueChega;
